import React, { Component } from 'react';
import IosSwitch from '../IosSwitch';
import DefaultButton from '../DefaultButton';
import DefaultLoader from '../DefaultLoader';
import ReportHelper from '../../helper/ReportHelper';
import moment from 'moment';
import { FormLabel } from '@material-ui/core';
import Firestore from '../../api/firebase/Firestore';
import SessionHelper from '../../helper/SessionHelper';
import ReportDefaultModalOptions from './ReportDefaultModalOptions';

export default class TournamentMatchReport extends Component {

    state = {
        loadingModal: true,
        studentDocs: [],
        users: [],
        courtDocs: [],
        courts: [],
        tournamentDocs: [],
        tournamentDoc: null,
        tournament: null,
        allCourts: true,
        allUsers: true,
        start: moment().startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
        output: 'download',
        format: 'pdf',
    }

    async componentDidMount() {

        if (this.props.getDocs && this.props.getDocs.length) {

            for (let index = 0; index < this.props.getDocs.length; index++) {
                
                const getDoc = this.props.getDocs[index];
                await getDoc(this);
            }
        }

        this.setState({ loadingModal: false });
    }

    async getReportDocs() {

        let docs = [];
        let tournament = this.state.tournamentDoc;

        let courts = this.state.allCourts ? this.state.courtDocs : this.state.courts;
        let courtDocs = [];

        courts.forEach((court, key) => {

            let courtDoc = court;

            if (!this.state.allCourts) {

                courtDoc = this.state.courtDocs.find(item => item.id === court);
            }

            courtDocs.push(courtDoc);
        });

        let query = await Firestore.customQuery('tournament_event').where('id_tournament', '==', this.state.tournamentDoc.id).where('id_company', '==', SessionHelper.getData().id_company).where('start', '>=', this.state.start).where('start', '<=', this.state.end).get();

        for (let doc of query.docs) {

            let findCourt = false;
            let event = { ...doc.data(), id: doc.id };
            let userNames = [];
            let idUsers = event.id_players;

            if (tournament.category[event.indexes.category].print && tournament.category[event.indexes.category].classes[event.indexes.class].print) {

                for (const user of idUsers) {
                
                    let query = await Firestore.getDoc('user', user);
                    let doc = { ...query.data(), id: query.id };
        
                    if (doc) {
                        
                        userNames.push(doc.name.split(' ')[0]);
    
                    } else {
    
                        userNames.push('Usuário Desconhecido');
                    }
                }
    
                let court = courtDocs.find(item => item.id === event.id_court);
                if (court) { findCourt = true };
    
                if (findCourt) {
    
                    docs.push({
                        date: `${moment(event.start.toDate()).format('DD/MM/YY HH:mm')} ~ ${moment(event.end.toDate()).format('HH:mm')}`,
                        court: court ? court.name : event.court ? event.court : 'Sem Localização',
                        students: userNames.join(', '),
                        type: 'Partida de Torneio',
                        round: `${tournament.category[event.indexes.category].title} - ${tournament.category[event.indexes.category].classes[event.indexes.class].title}`
                    });
                }
            }
        }

        docs.sort((a, b) => {

            return a.date > b.date;
        });

        return docs;
    }

    async print() {

        this.setState({ loadingModal: true });

        let docs = await this.getReportDocs();
        let name = `Partidas - ${this.state.tournamentDoc.name}`;
        let subtitle = `De ${moment(this.state.start).format('DD/MM/YYYY HH:mm')} Até ${moment(this.state.end).format('DD/MM/YYYY HH:mm')}`;
        let report = await ReportHelper.createReport(name, 5, subtitle);

        report = await ReportHelper.createColumns(report, docs, [
            { name: 'Data', width: 13, getText: (doc) => doc.date },
            { name: 'Quadra', width: 55, getText: (doc) => doc.court },
            { name: 'Categoria', width: 90, getText: (doc) => doc.round },
            { name: 'Jogadores', width: 130, getText: (doc) => doc.students },
        ]);

        ReportHelper.print(report, this.state.output, this.state.format);

        this.setState({ loadingModal: false });
    }

    renderLoading() {

        return (

            <div style={{ height: 200 }}>
                <DefaultLoader/>
            </div>
        )
    }

    handleTournamentChange(value) {

        let doc = this.state.tournamentDocs.find(item => item.id === value);
        this.setState({ tournamentDoc: doc, start: doc.start.toDate(), end: doc.end.toDate() });
    }
    
    renderModal() {

        return (

            <div>
                { ReportHelper.renderTournamentSelection(this, this.state.tournamentDocs, 'tournament', (value) => { this.handleTournamentChange(value) }) }

                { this.state.tournamentDoc ? <FormLabel style={{ paddingBottom: 18 }} component="legend">Selecione as Classes</FormLabel> : null }
                {
                    this.state.tournamentDoc ?

                        this.state.tournamentDoc.category.map((category, key) => {

                            if (category.checked) {

                                return (

                                    <div>
                                        <IosSwitch fullWidth label={category.title} checked={category.print} onChange={(e) => { let tournament = this.state.tournamentDoc; tournament.category[key].print = e; this.setState({ tournamentDoc: tournament }) }} />
                                        
                                        {
                                            this.state.tournamentDoc.category[key].print ? 

                                                this.state.tournamentDoc.category[key].classes.map((categoryClass, classKey) => {
                                                    
                                                    if (categoryClass.checked) {

                                                        return (
                                                            <div style={{ marginLeft: 20 }}>
                                                                <IosSwitch fullWidth label={categoryClass.title} checked={categoryClass.print} onChange={(e) => { let tournament = this.state.tournamentDoc; tournament.category[key].classes[classKey].print = e; this.setState({ tournamentDoc: tournament }) }} />
                                                            </div>
                                                        )
                                                    }
                                                })

                                            : null
                                        }
                                        
                                    </div>
                                )
                            }
                        })

                    : null
                }

                <IosSwitch fullWidth label={'Todas as Quadras'} checked={this.state.allCourts} onChange={(e) => { this.setState({ allCourts: e, courts: [] }) }} />
                { !this.state.allCourts ? ReportHelper.renderCourtSelection(this, this.state.courtDocs, 'courts') : null }

                { ReportHelper.renderPeriodSelection(this, 'start', 'end', 'dd/MM/yyyy HH:mm') }
                
                <ReportDefaultModalOptions onOutputChange={(value) => { this.setState({ output: value }) }} onFormatChange={(value) => { this.setState({ output: value }) }}/>
                <div style={{alignSelf: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 50}}>
                    <DefaultButton width={'100%'} title={'Imprimir'} onClick={() => { this.print() }} />
                </div>
            </div>
        )
    }

    render() {

        return (

            this.state.loadingModal ? this.renderLoading() : this.renderModal()
        )
    }
}